export enum Global {
    Merge = "MergeClients"
}

export enum Billing {
    AccessBilling = "AccessBilling",
    CanCancelSubscription = "CanCancelSubscription",
}

export enum SuperAdmin {
    Access = "Admin.Access",
    CreateClinics = "Admin.CreateClinics",
    ManageClinics = "Admin.ManageClinics",
    ManageItems = "Admin.ManageLookup",
}

export enum Accounting {
    View = "ViewAccounting",
    Modify = "ModifyAccounting",
    CanRemovePayments = "CanRemovePayments",
    CanEditServicePrice = "CanEditServicePrice",
}

export enum Calendar {
    View = "ViewCalendar",
    Modify = "ModifyCalendarSettings",
}

export enum Clients {
    View = "ViewClients",
    Modify = "ModifyClients",
}

export enum DirectorMetrics {
    View = "ViewDirectorMetrics",
    Modify = "ModifyDirectorMetrics",
}

export enum OnlineUsers {
    View = "ViewOnlineUsers",
}

export enum Reports {
    View = "ViewReports",
    Modify = "ModifyReports",
}

export enum Settings {
    View = "ViewSettings",
    Modify = "ModifySettings",
    PreventClinicSwitch = "PreventClinicSwitch",
}

export enum Users {
    View = "ViewUserRoles",
    Modify = "ModifyUserRoles",
}

export enum Appointments {
    NoShow = "CanNoShowAppointments",
    Delete = "CanDeleteAppointments",
    Cancel = "CanCancelAppointments",
    MakeAppointments = "MakeAppointments",
}

export default {
    Global,
    Billing,
    Accounting,
    Appointments,
    Calendar,
    SuperAdmin,
    Clients,
    DirectorMetrics,
    OnlineUsers,
    Reports,
    Settings,
    Users
}